<template>
    <el-container class="home is-vertical">
      <el-header class="header_Div">
        <Header></Header>
      </el-header>
      <el-container>
        <el-aside id="leftMain" class="leftMain">
          <Nav :userParams="params"></Nav>
        </el-aside>
        <el-main>
          <el-header class="tag_Div" style="height:56px">
            <AppTag></AppTag>
          </el-header>
					<router-view></router-view>
        </el-main>
      </el-container>
  </el-container>
</template>


<script>
import Header from "./common/header";
import AppTag from "./common/apptag";
import Nav from "./common/nav";

export default {
  data: function() {
    return {
      message: "",
      params: ''
    };
  },
  components: {
    Header,
    Nav,
    AppTag
  },
  methods: {
  },
  mounted() {
    if (this.common.getClient()) {
      /*window.location.href="你的手机版地址";*/
      $("#leftMain").width(64)
    }else {
      $("#leftMain").width(210)
    }
  }
};
</script>

<style>
.header_Div {
  background-color: #0fa0ec !important;
  width: 100% !important;
  margin: 0 !important;
}
.el-tabs--border-card {
  border: none !important;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #606266 !important;
  background-color: #fff !important;
  border-right-color: #F2F6FC !important;
  border-left-color: #F2F6FC !important;
}

.el-tabs--border-card>.el-tabs__header {
  padding: 4px 0px;
  background-color: #fff !important;
}

.el-tabs--border-card>.el-tabs__header>.el-tabs__nav {
  padding: 0 !important;
}
.el-main {
  padding: 0px !important;
}
.tag_Div {
  height: auto !important;
  padding: 0px!important;
}
.el-tabs >.el-tabs__header {
  margin: 0 !important;
}
.el-form--inline {
  padding: 0 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue